import type { AssetCreationRequest, AssetType } from '@graphql/default/types';
import { AssetCreationRequestStatus } from '@graphql/default/types';

export const mapProcessingCreatedAssets = (
  assetCreationRequestsResponsesList: AssetCreationRequest[],
  previousIterationCreatedAssets: Record<
    string,
    { assetType: string; assetId: string }
  >,
) =>
  assetCreationRequestsResponsesList
    .filter(({ status }) => status === AssetCreationRequestStatus.Completed)
    .reduce(
      (acc, { id, assetId, assetType }) => {
        if (assetId && assetType) {
          acc[id] = { assetId, assetType };
        }
        return acc;
      },
      { ...previousIterationCreatedAssets } as Record<
        string,
        { assetId: string; assetType: AssetType }
      >,
    );
